<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card elevation="4" light>
          <v-form v-model="valid" @submit.prevent="login">
            <v-container>
              <v-row justify="center">
                <v-col>
                  <h6 class="text-h6">
                    Sign In
                  </h6>
                  <small classs="text-caption">
                    Don't have an account?<br>
                    <a href="/register">Click here</a> to register.
                  </small>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                  ></v-text-field>
                </v-col>
      
                <v-col cols="12">
                  <v-text-field
                    v-model="password"
                    :rules="passwordRules"
                    :counter="16"
                    label="Password"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-btn color="primary" type="submit" :disabled="!valid">
                    Sign In
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import firebase from 'firebase';
  export default {
    data: () => ({
      valid: false,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],

      password: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => v.length > 7 || 'Password must be at least 8 characters.',
        v => v.length <= 16 || 'Password must be less than 16 characters.',
      ],
    }),

    methods: {
      login() {
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            alert('Successfully logged in');
            this.$router.push('/');
          })
          .catch(error => {
            alert(error.message);
          });
      },
    }
  }
</script>